module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Introduction: Education for the Common Good in a Diverse World"
    }
  }, [_c('p', {
    staticClass: "h2-c"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/00a_Yob_and_Jorgensen_fm_prod0d#intro"
    }
  }, [_c('b', [_vm._v("INTRODUCTION")])])])]), _vm._v(" "), _c('p', {
    staticClass: "h2-ct1"
  }, [_c('i', [_c('a', {
    attrs: {
      "href": "#/text/00a_Yob_and_Jorgensen_fm_prod0d#intro"
    }
  }, [_vm._v("Education for the Common Good in a Diverse World")])])]), _vm._v(" "), _c('p', {
    staticClass: "CH-AU"
  }, [_c('a', {
    attrs: {
      "href": "#/text/00a_Yob_and_Jorgensen_fm_prod0d#intro"
    }
  }, [_vm._v("Iris M. Yob")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("A")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("QUIET, BOOKISH YOUNG MAN WALKED INTO")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LISON")]), _vm._v(" Beavan’s honors chorus at Nauset High School on Cape Cod, Massachusetts, back in 2002. The moment was the beginning of a transformation. In his own assessment of the experience, Julian reports that he gained confidence and poise, his self-esteem grew, and he found his voice—literally and figuratively. Then word came down that the Nauset Regional School District had a $1.8 million budget gap. If left unfilled by voters at the Town Meeting, forty teaching and staff positions would be cut, including Alison Beavan’s. Confronted by the likely elimination of his favorite teacher and the music department, Julian mobilized a student-led effort to persuade voters at four town meetings to fully fund the budget with a Proposition 2½ override. He and his classmates wrote a brochure to taxpayers outlining what would be lost to quality education if the cuts were sustained and mailed it to thousands of households; he and his peers made impassioned speeches about the vitality of a quality education, one that included music and the arts. Their efforts were successful, and the budget override was passed at all four town meetings.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Today that young man, Julian Cyr, is a member of the Massachusetts State Senate, where he works hard on issues around clean water, affordable housing, the impact of changing climate patterns, employment opportunities, substance abuse, education, the value of music and arts education, and other issues that can improve the lives of people in his district and across the commonwealth. At the heart of this good-news story is a music educator, Ms. Beavan. Her work with the young people in her school chorus exemplifies the double-pronged influence teachers can have on the greater public welfare: first by the positive and humane impact they can have on the lives of individuals in their classes and then by giving those students "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  }, [_vm._v("the confidence and imagination, along with the skills and knowledge, to contribute to the common good.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is the vision guiding the recent United Nations Educational, Scientific, and Cultural Organization (UNESCO) report, "), _c('i', [_vm._v("Rethinking Education: Towards a Global Common Good?")]), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch00rfn1",
      "id": "ch00fn1"
    }
  }, [_vm._v("1")])]), _vm._v(" It suggests how education can respond to the challenges of our day in purpose, policy, and pedagogy in a way that respects and nurtures all members of the human family. Against this backdrop, the humanities and the arts have an important and even unique role to play, for it is in these arenas of endeavor among others that the human spirit finds expression and can be nurtured. The contributors to this collection explore, analyze, apply, critique, and expand these ideas as they relate to music education. More precisely, the contributors investigate how the music classroom, studio, rehearsal space, performance venue, religious site, and wherever else there is music making and music taking can be centers for contributing to the common good. The central question addressed by our writers in this collection is the following: How can music education, by adopting a humane approach across its many contexts and for its variety of learners, contribute to the common good?")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("The UNESCO Reports")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The 2015 report "), _c('i', [_vm._v("Rethinking Education")]), _vm._v(" follows two preceding reports from UNESCO: "), _c('i', [_vm._v("Learning to Be: The World of Education Today and Tomorrow")]), _vm._v(" (1972), also known as the Faure report, and "), _c('i', [_vm._v("Learning: The Treasure Within")]), _vm._v(" (1996), referred to as the Delors report."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch00rfn2",
      "id": "ch00fn2"
    }
  }, [_vm._v("2")])]), _vm._v(" The writing teams, made up of “Senior Experts” in the field of education, were commissioned to analyze the challenges to education around the world at the time of writing and the educational practices responding to those challenges, and then offer recommendations for aligning education more closely with the realities of the day."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch00rfn3",
      "id": "ch00fn3"
    }
  }, [_vm._v("3")])]), _vm._v(" It is interesting to follow the development of ideas and the continuities/discontinuities across time and across these successive publications with the same intent and from the same source.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In one instance of discontinuity among the reports, the Faure report was written and presented by an all-male team and, not surprisingly, couched in the male-dominated language of the day, suggesting to readers a very masculine view of education and its role in the world, with talk of the complete man, his nature, his potential, his progress, his technology, and his genius. The report, however, did lament higher illiteracy rates among "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_3",
      "title": "3"
    }
  }, [_vm._v("women and girls and their lower participation in schooling as one indicator of a developing nation compared with an industrialized one."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch00rfn4",
      "id": "ch00fn4"
    }
  }, [_vm._v("4")])]), _vm._v(" The Delors team, which included a better balance of men and women, also addressed the topic of the education of women and girls, strongly and explicitly encouraging greater focus on their development. "), _c('i', [_vm._v("Rethinking Education")]), _vm._v(" adds the violence against women and girls around the world and the lack of educational access afforded to them as explicit areas of social concern and action in the world of the twenty-first century.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another discontinuity from report to report is the striking way in which they move successively away from a modernist understanding of the role of education to a more postmodernist stance. In the first of the series, straightforward assertions were offered on a number of topics and data sets, leading directly to announcing goals and processes for education. This confidence was bolstered even more by the second report, which unabashedly saw the right kind of education leading to “utopia” for all, and words such as "), _c('i', [_vm._v("universal")]), _vm._v(" are found throughout—although even in this report, the modernist bent is somewhat ameliorated by acknowledgement of “the value of a cautious measure of decentralization.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch00rfn5",
      "id": "ch00fn5"
    }
  }, [_vm._v("5")])]), _vm._v(" By 2015, however, the certainty in tone is diminished. The world is seen much more for its complexity and diversity. Even the subtitle of this last publication suggests less assurance about providing a unanimous and comprehensive plan for the future of education world-wide, concluding with a question mark—"), _c('i', [_vm._v("Towards a Global Common Good?—")]), _vm._v("where “towards” suggests adaptability and flexibility going forward, and the very idea of a “common good” is questioned. Addressing this latter point, the writers significantly propose that the “diversity of contexts and conceptions of well-being and common life” help frame what we mean by “the common good.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch00rfn6",
      "id": "ch00fn6"
    }
  }, [_vm._v("6")])]), _vm._v(" In fact, this report sidesteps the term "), _c('i', [_vm._v("public good")]), _vm._v(" to avoid the impression of supporting some universally applicable goal."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch00rfn7",
      "id": "ch00fn7"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is interesting to note, however, that even in the discontinuities, it is possible to see the gradual development of the basic principles that underscore all three reports. By moving away from a more paternalistic, patriarchal, universalistic account to a more gender-neutral, inclusive, and adaptable one, the series represents a growing sense of what participatory inclusiveness and diversity actually mean.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Each of the reports was published in response to a time when the world seemed to be changing, technology was burgeoning, international connectedness was becoming more apparent, and educational practices needed to "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4",
      "title": "4"
    }
  }, [_vm._v("be renewed to meet these challenges. All three reports promoted educational methods and content believed to be more in keeping with the times and extended learning across the lifespan."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch00rfn8",
      "id": "ch00fn8"
    }
  }, [_vm._v("8")])]), _vm._v(" While underscoring the importance of accountability, "), _c('i', [_vm._v("Rethinking Education")]), _vm._v(" affirms the importance of “multiple learning pathways” to reinvigorate “the relevance of education that is life-long and life-wide.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch00rfn9",
      "id": "ch00fn9"
    }
  }, [_vm._v("9")])]), _vm._v(" It identifies “open and flexible . . . learning systems” as critical in the “validation and assessment of knowledge and competencies.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch00rfn10",
      "id": "ch00fn10"
    }
  }, [_vm._v("10")])]), _vm._v(" It further identifies “keys” that can transform learning to meet the challenges in the early twenty-first century: “an ethical foundation, . . . critical thinking, independent judgement, problem-solving, and information and media literacy skills.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch00rfn11",
      "id": "ch00fn11"
    }
  }, [_vm._v("11")])]), _vm._v(" It envisions moving away from traditional educational institutions and methods toward “networks of learning,” “mixed, diverse and complex learning landscapes in which formal, non-formal, and informal learning occur through a variety of educational institutions and third-party providers.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch00rfn12",
      "id": "ch00fn12"
    }
  }, [_vm._v("12")])])])]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Humane Education for the Common Good")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("One of the most obvious continuities across all the reports is that each takes a humanistic approach and proposes a humane education, although how those views are expressed takes on the flavor of the time in which they were written. Throughout the series of reports, the term "), _c('i', [_vm._v("humanistic")]), _vm._v(" is not spelled with an uppercase "), _c('i', [_vm._v("H")]), _vm._v(" but rather a lowercase "), _c('i', [_vm._v("h")]), _vm._v(", because it does not refer to a narrow philosophic tradition. Rather, the humanism spoken of in the reports is to be understood to mean a human-centered, human-focused, science-based approach to education. Humankind, writ large, is meant to be the object, purpose, and focus of educational endeavors, and humanity in all its varieties is to be taken into account, regardless of whether particular humans live in poverty or affluence, in underdeveloped, developing, or developed countries, or have present access to good schooling or not. It is the welfare of the whole human family that motivates the contributors to this series of reports.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The humanistic theme is introduced in the Faure report. One fear of the writers of this report was that the human race would continue to fracture apace into “superior and inferior groups, into masters and slaves, supers ["), _c('i', [_vm._v("sic")]), _vm._v("] men and submen” because of differences among peoples in their advantages and privileges. They worried that the human family could lose its “unity” and “future as a species” and even “man’s identity” if educators "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_5",
      "title": "5"
    }
  }, [_vm._v("among others did not intervene."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch00rfn13",
      "id": "ch00fn13"
    }
  }, [_vm._v("13")])]), _vm._v(" Interestingly, they noted that education itself contributed to the disparity among peoples for learning had benefitted from the technological and scientific advances of some societies, advances which had “affect[ed] man’s most profound characteristics and, in a manner of speaking, renew[ed] his genius,”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch00rfn14",
      "id": "ch00fn14"
    }
  }, [_vm._v("14")])]), _vm._v(" while other societies had not experienced these advances and concomitant developments in economics, politics, and health and well-being. The suggestion was that for some a process of “dehumanisation” ensued from the lack of these advantages, which should be addressed by a humanizing education that occurred across the life span and by “learning societies” wherever human beings happen to be."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch00rfn15",
      "id": "ch00fn15"
    }
  }, [_vm._v("15")])]), _vm._v(" The humanism adopted by the writers of the Faure report does not subscribe to idealistic, subjective, or abstract views of what a human being is. Rather, their focus was on “a concrete being, set in a historical context, in a set period. [This conception] depends on objective knowledge, but that which is essentially and resolutely directed towards action and primarily in the service of man himself.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch00rfn16",
      "id": "ch00fn16"
    }
  }, [_vm._v("16")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While these humanistic notions were laid out in the Faure report, the Delors report made them even more explicit and central. This began with the title of the report: "), _c('i', [_vm._v("Learning: The Treasure Within")]), _vm._v(", which immediately draws attention to the potential of the human learner. In the opening paragraph, the Delors report stated, “Education is . . . an expression of affection for children and young people, whom we need to welcome into society, unreservedly offering them the place that is theirs by right therein.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch00rfn17",
      "id": "ch00fn17"
    }
  }, [_vm._v("17")])]), _vm._v(" He added that when the members of the UNESCO Commission accepted their mandate, they also accepted that “while education is an ongoing process of improving knowledge and skills, it is also—perhaps primarily—an exceptional means of bringing about personal development and building relationships among individuals, groups and nations.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch00rfn18",
      "id": "ch00fn18"
    }
  }, [_vm._v("18")])]), _vm._v(" Early in the document, the Delors report introduced a theme that develops later: education is the “continuous process of forming whole human beings,” later reformulated as the “four pillars of learning”: “learning to know,” “learning to do,” “learning to live together,” and “learning to be”—the latter two pointing directly beyond the acquisition of knowledge and practical skills to education’s additional tasks in developing the whole person."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch00rfn19",
      "id": "ch00fn19"
    }
  }, [_vm._v("19")])]), _vm._v(" This formulation has found particular resonance with several of the writers in the present collection as they argue that music education can have a vital part to play in promoting development in all areas of human potential, especially in living together and being fully human."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch00rfn20",
      "id": "ch00fn20"
    }
  }, [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_6",
      "title": "6"
    }
  }, [_c('i', [_vm._v("Rethinking Education")]), _vm._v(" is clear about the humanistic approach it is built on: “Sustaining and enhancing the dignity, capacity and welfare of the human person, in relation to others and to nature, should be the fundamental purpose of education in the twenty-first century.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch00rfn21",
      "id": "ch00fn21"
    }
  }, [_vm._v("21")])]), _vm._v(" The writers acknowledge that humanism, narrowly understood, has been criticized by “post-modernists, some feminists, [and] ecologists” for its exclusive and limited focus on humankind and more recently by “trans-humanists or even post-humanists” who would improve the human species through “natural selection” or “radical enhancements.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch00rfn22",
      "id": "ch00fn22"
    }
  }, [_vm._v("22")])]), _vm._v(" Nevertheless, they remain firm in their commitment to a humanistic approach to education for it takes a wider moral vision that values human beings not because of the part they might play in economic development but because they simply are, and hence it values all human beings without exclusion or marginalization."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch00rfn23",
      "id": "ch00fn23"
    }
  }, [_vm._v("23")])]), _vm._v(" Under this rubric, the purpose and foundation of humane or humanistic education for these writers lie in these ideals: “respect for life and human dignity, equal rights and social justice, cultural and social diversity, and a sense of human solidarity and shared responsibility for our common good.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch00rfn24",
      "id": "ch00fn24"
    }
  }, [_vm._v("24")])]), _vm._v(" In the light of these ideals, they reaffirm and reinterpret the four pillars of education enunciated in the Delors report, giving a particular nod to learners with disabilities, gender equality, multicultural learning societies, and consequently alternative learning spaces and teaching methods, each of which is explored in the context of music education by contributors to the present collection."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch00rfn25",
      "id": "ch00fn25"
    }
  }, [_vm._v("25")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Integral with the notion of humane education, the “common good” or more particularly, “a global common good,” is another central continuity among the three UNESCO reports. Given the mandates of the three taskforces that produced the reports—that they should address the challenges and opportunities facing societies and education across the world of their times—this is not surprising. Education for the common good is a theme that has persisted in educational thought and has, in some instances, even become an assumption that no longer needs justification."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch00rfn26",
      "id": "ch00fn26"
    }
  }, [_vm._v("26")])]), _vm._v(" In the Faure report, the writers did not use the expression, “the common good,” but they nevertheless adopted it in spirit by taking the view that the right kind of education can contribute to the transformation and progress of society."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch00rfn27",
      "id": "ch00fn27"
    }
  }, [_vm._v("27")])]), _vm._v(" For its part, they suggested, “education may help society to become aware of its problems” and, by a holistic training, prepare people who “will consciously seek their individual and collective emancipation, . . . [and] may greatly contribute to changing and humanizing societies.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch00rfn28",
      "id": "ch00fn28"
    }
  }, [_vm._v("28")])]), _vm._v(" The focus of "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7",
      "title": "7"
    }
  }, [_vm._v("the Faure report was not narrowed to European or Western society but took a global perspective, and the influence it envisioned embraced the whole world, as it pointed to “gaps” between societies, addressing directly such issues as environmental degradation and the need to imbue students with the principles and skills of democracy."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch00rfn29",
      "id": "ch00fn29"
    }
  }, [_vm._v("29")])]), _vm._v(" The report closely tied the issue of learning democratic principles and skills to the notion of the common good, describing the close connection between the two in the following words: “an individual comes to a full realization of his own social dimensions through an apprenticeship of active participation in the functioning of social structures and, where necessary, through a personal commitment in the struggle to reform them.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch00rfn30",
      "id": "ch00fn30"
    }
  }, [_vm._v("30")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Delors report took up this idea and expanded on it."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch00rfn31",
      "id": "ch00fn31"
    }
  }, [_vm._v("31")])]), _vm._v(" Apart from the image of “four pillars” of education, it used a number of other metaphors to capture the sense of the global common good in what the authors pictured as an increasingly “crowded planet.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch00rfn32",
      "id": "ch00fn32"
    }
  }, [_vm._v("32")])]), _vm._v(" The notion of a utopia was introduced in the first chapter. The writers did not intend to conjure an image of a world where all problems are solved and all ideals are realized, but rather an idealistic vision of the goals of education as the “principal means available to foster a deeper and more harmonious form of human development and thereby to reduce poverty, exclusion, ignorance, oppression and war.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch00rfn33",
      "id": "ch00fn33"
    }
  }, [_vm._v("33")])]), _vm._v(" Such a vision was not to be limited to privileged societies but was for all societies as they partnered together to bring about this worldwide harmony. The writers applied “the global village” metaphor to capture this idea and implied this vision could be realized through international cooperation in sharing monetary resources; aiming for an inclusive education that would embrace everyone, across the lifespan, giving special attention to neglected women and girls; and bringing the technology of the information age to all."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch00rfn34",
      "id": "ch00fn34"
    }
  }, [_vm._v("34")])]), _vm._v(" Another metaphor the Delors report introduced was that of the “learning society” in which all are learners, regardless of position or age, and more significantly, where ongoing learning enhances society and society embodies and supports learning in a reciprocal relationship."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch00rfn35",
      "id": "ch00fn35"
    }
  }, [_vm._v("35")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Building on the primary sentiments of the earlier reports, "), _c('i', [_vm._v("Rethinking Education")]), _vm._v(" is the first to name the connection between society and education (of the Faure report) or the idealistic vision of education (of the Delors report) as a movement toward the common good. They identify the common good, reframed at times as “common goods,” as education and knowledge, and provide three dimensions of the common good (as opposed to "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8",
      "title": "8"
    }
  }, [_vm._v("simple public good): it is related to “the goodness of the life that humans hold in common”; it is “defined with regard to diversity of contexts and conceptions of well-being and common life”; and it is a “participatory process” where “shared action is intrinsic, as well as instrumental, to the good itself.” In other words, it implies “an inclusive process of public policy formulation” and aspires “towards new forms and institutions of participatory democracy.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch00rfn36",
      "id": "ch00fn36"
    }
  }, [_vm._v("36")])]), _vm._v(" In these descriptors, a couple of tensions appear: between what is common and what is responsive to diversity and between what is a common good and what are common goods. By not explicitly resolving these tensions, the writers of this report allow for multiple interpretations under their general principles of humanism, education, democracy, and development."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch00rfn37",
      "id": "ch00fn37"
    }
  }, [_vm._v("37")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is apparent that the notions of humane education and the common good are inseparable in these reports. A humane, humanistic, or human-centered (terms that seem to be interchangeable in this account) education enhances, nurtures, and promotes the highest development of every individual. This is true whether the individual is an immigrant child in a boat that washes ashore in Greece, a transgender individual in the choir, a nonsinger and nonmusician in the learning community, a differently abled participant, or a learner whose culture and values portend a different kind of music and music production—as writers in this present collection argue. In a humane (inclusive, responsive, participatory) education, the humanness of humankind is enhanced, nurtured, and promoted. And that in essence is the common good. By the same logic, the common good is better understood as common goods, indicating that it is made up of what is good for each individual. And what is good for the individual is a humane education that promotes and nurtures his or her human potential. This account assumes a codependence between humane education and the common good, and so the two notions can be readily conflated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Furthermore, whether one is talking about the individual or the larger society, the promotion of human good is to be done without regard to where that learner is found, whether in a school classroom, a teacher-education seminar, a prison, a religious setting, or a private studio, as other writers in this collection show. So both notions—humane education and the common good—have a social justice edge in that they would activate teachers, curriculum builders, policy makers, and in fact all of us to dismantle the barriers that would prevent anybody from full participation in these lofty aims of democracy, development, and a holistic education.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "title": "9"
    }
  }, [_vm._v("And yet, there is a distinction between the two notions, humane education and the common good. Educators should aim for both, but humane education points more to the means of achieving the common good and the common good more to the ultimate goal of humane education. In essence, although they are inseparable, humane education is the foundation of the common good, and the common good is the outcome of a humane education. There can be no service toward the common good if that service is not inclusively humane through and through. No common good is possible if the welfare of any single member of the human family is not humanely understood and their needs, context, and personal potential addressed. It is the concern for each individual that modifies “common good” toward “common goods” because individual needs, possibilities, and challenges are not reducible to a single good unless that common good is understood in a most encompassing way. The larger welfare of humankind depends on the humane education of every member of the human family.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Reduced to these basic premises, the vision of "), _c('i', [_vm._v("Rethinking Education")]), _vm._v(" is radical, maybe even too radical. It conveys the sense that a humane education, conducted in various ways, times, and places across the lifespan, is the sole means toward the common good. In some fundamental, inescapable way, it alone will eliminate inequality, violence, poverty, and destruction of the environment and create peace between nations, democratic institutions, and prosperous societies. Realistically speaking, however, we know that much more needs to come together for this dream to be fulfilled, and several writers in the present collection point this out and even question its absolutist claims. Nevertheless, however we might modify and adjust the vision of "), _c('i', [_vm._v("Rethinking Education")]), _vm._v(" in the light of lived realities and alternate understandings, the right kind of education may yet remain pivotal in making the world a better place: reaching for the common good rests at least in part on a humane approach to learning and learners.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the chapters that follow, the writers respond to "), _c('i', [_vm._v("Rethinking Education: Towards a Common Good?")]), _vm._v(" in the context of music education. The first and last sections are more reflective and bookend the two middle sections that are more practical in their focus. “"), _c('a', {
    attrs: {
      "href": "#/text/Part01"
    }
  }, [_vm._v("Part I")]), _vm._v(": Critique and Clarification” examines the premises of "), _c('i', [_vm._v("Rethinking Education")]), _vm._v(". Iris M. Yob analyzes the tensions inherent in talk about both the "), _c('i', [_vm._v("common")]), _vm._v(" good and common "), _c('i', [_vm._v("goods")]), _vm._v(", between focus on the individual and the whole human family. Randall Everett Allsup raises the specter of whether there really can be an international humanism and whether a common good can be realized when rational "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "title": "10"
    }
  }, [_vm._v("beings, at the personal or public level, cannot agree. Hanne Rinholm and Øivind Varkøy warn music educators against the kind of hubris that would lead them to expect more than music education can deliver in making the world a better place. Kevin Shorner-Johnson raises significant questions about the linear notion of progress exhibited in all three of the UNESCO reports and proposes that educators consider instead a diversity of temporalities and alternative experiences of the flow of time and what that might do for individual and community development toward the common good. Ebru Tuncer Boon, recounting the Gezi Park uprising in Istanbul, explores the nexus between political activism and the creative arts and how the former can lead to an explosion in the latter and vice versa, casting the arts in a central role in activism for the common good.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('span', {
    attrs: {
      "href": "#/text/Part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part II")]), _vm._v(": Principles and Practices of Music Teaching” explores some of the practical applications of "), _c('i', [_vm._v("Rethinking Education")]), _vm._v(" to the work of preparing music educators. Betty Anne Younker builds on the legacy of progressive education and makes the case for inquiry-based learning as an essential pedagogy for moving toward the common good. Christine Brown draws on the humanistic writings of Abraham Maslow and Carl Rogers to suggest principles for teaching in the piano studio. Emily Howe, André de Quadros, Andrew Clark, and Kinh T. Vu share what they have learned as music educators by working in diverse settings outside of the traditional classroom, specifically with inmates and disabled learners and with issues faced by people of another cultural heritage and location. Joseph Shively explores the qualities of music teacher preparation that is based on humanistic principles.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('span', {
    attrs: {
      "href": "#/text/Part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part III")]), _vm._v(": Educating Others for the Common Good” suggests how specific contexts of music education or the needs and interests of particular learners can be addressed to enact the vision of "), _c('i', [_vm._v("Rethinking Education")]), _vm._v(". Luca Tiszai describes the social benefits of bringing together people of different ages and abilities in community music making, benefits that are mutual and boundary-shaking. Emily Good-Perkins helps us see how cultural diversity in vocal music education is manifested and can be included to expand students’ understanding and appreciation of difference. Blakeley Menghini draws parallels between the principles outlined in "), _c('i', [_vm._v("Rethinking Education")]), _vm._v(" and the Suzuki Method and draws on her practical experience to show how those principles can be maximized. Mary Thomason-Smith describes a particular case, set not in a traditional classroom but a sacred community, as an exemplar of where music education can promote an understanding of "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "title": "11"
    }
  }, [_vm._v("and involvement in addressing a pressing global issue of our times. Jacob Axel Berglin and Thomas Murphy O’Hara illustrate a variety of approaches open to the music educator in providing a hospitable place for the transgender student.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('span', {
    attrs: {
      "href": "#/text/Part04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part IV")]), _vm._v(": Elaborations and Expansions” points to some areas for continuing and future development in music education beyond what is gleaned from "), _c('i', [_vm._v("Rethinking Education")]), _vm._v(". Johnnie-Margaret McConnell and Susan Laird outline the very human need for musicking and the benefits of reaching out to satisfy the musical hunger of those who are not in traditional music classes. Deanne Bogdan picks up on the theme of holistic education by describing the chronic dissociation of thought and feeling and how they might be reintegrated in literature and, by comparison, music, and how music itself might be integrated into a whole when it brings the Other into a place where there is no Other. Alexandra Kertz-Welzel, Leonard Tan, Martin Berger, and David Lines, representing Germany, Singapore, South Africa, and New Zealand, respectively, illustrate cultural diversity in music and how education systems in these countries are addressing these differences and developing inclusive music education programs. Eleni Lapidaki addresses an omission in "), _c('i', [_vm._v("Rethinking Education")]), _vm._v(" by describing and illustrating intimacy and trust as key features in inclusive and humane music education.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the conclusion, Estelle Jorgensen gathers together the themes of the collection across critiques and clarifications, pedagogies and approaches to music educator preparation, the diversity of learners and sites for learning, and elaborations and expansions as we think about the future of music education. She connects these again to the central ideas of "), _c('i', [_vm._v("Rethinking Education")]), _vm._v(" and shows how they promote a clearer, more realistic, and imaginative understanding of how music education can be humane and directed toward the common good.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At this point in time, the 2015 UNESCO publication is prescient in many respects but strikes one as out of date in others, so fast-paced are the social, political, economic, technological, and musical worlds we live in today. Because of this, this present collection does not give a comprehensive plan for what music education should be going forward, for that would limit its vision to what we can imagine now. The writers included in this collection responded to a call for papers for the journal "), _c('i', [_vm._v("Philosophy of Music Education Review")]), _vm._v(", announced on the Facebook page of the journal. The response was so immediate and so broad that the journal could not publish them all even over the course of multiple issues. So the idea of publishing "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "title": "12"
    }
  }, [_vm._v("them as a book collection was conceived. The editors thought the set of proposed papers as a book would do more justice to the topic of humane music education for the common good. The writers of this collection are from New Zealand, South Africa, Norway, Cambodia, Singapore, Turkey, Hungary, Greece, Germany, the United States, and Canada. They include graduate students at the beginning of their careers and retiring professors at the end of theirs and every stage in between. They come from the ranks of studio teachers, K-12 teachers, professors of music, choir conductors, curriculum specialists, administrators, philosophers and theoreticians, and exponents of Kodály and Suzuki. And yet, clearly, there are voices left unheard in this collection and perspectives and applications unexplored. The best this collection can do is to begin a conversation and open possibilities to new thinking and doing in music education that would make it humane in service of the common good.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("IRIS M. YOB is Faculty Emerita and Contributing Faculty Member in the Richard W. Riley College of Education and Leadership at Walden University, Minnesota.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Notes")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "ch00rfn1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch00fn1"
    }
  }, [_vm._v("1")]), _vm._v(". UNESCO, "), _c('i', [_vm._v("Rethinking Education: Towards a Global Common Good?")]), _vm._v(" (Paris: UNESCO, 2015), "), _c('a', {
    attrs: {
      "href": "http://unesdoc.unesco.org/images/0023/002325/232555e.pdf",
      "target": "_blank"
    }
  }, [_vm._v("http://unesdoc.unesco.org/images/0023/002325/232555e.pdf")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "ch00rfn2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch00fn2"
    }
  }, [_vm._v("2")]), _vm._v(". UNESCO, "), _c('i', [_vm._v("Learning to Be: The World of Education Today and Tomorrow")]), _vm._v(" (Paris: UNESCO, 1972), "), _c('a', {
    attrs: {
      "href": "http://unesdoc.unesco.org/images/0000/000018/001801e.pdf",
      "target": "_blank"
    }
  }, [_vm._v("http://unesdoc.unesco.org/images/0000/000018/001801e.pdf")]), _vm._v(" (hereafter referred to as the Faure report); UNESCO, "), _c('i', [_vm._v("Learning: The Treasure Within")]), _vm._v(" (Paris, UNESCO, 1996), "), _c('a', {
    attrs: {
      "href": "http://unesdoc.unesco.org/images/0010/001095/109590eo.pdf",
      "target": "_blank"
    }
  }, [_vm._v("http://unesdoc.unesco.org/images/0010/001095/109590eo.pdf")]), _vm._v(" (hereafter referred to as the Delors report).")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "ch00rfn3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch00fn3"
    }
  }, [_vm._v("3")]), _vm._v(". UNESCO, "), _c('i', [_vm._v("Rethinking Education")]), _vm._v(", 5.")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "ch00rfn4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch00fn4"
    }
  }, [_vm._v("4")]), _vm._v(". UNESCO, Faure report, 52.")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "ch00rfn5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch00fn5"
    }
  }, [_vm._v("5")]), _vm._v(". Ibid., 27.")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "ch00rfn6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch00fn6"
    }
  }, [_vm._v("6")]), _vm._v(". UNESCO, "), _c('i', [_vm._v("Rethinking Education")]), _vm._v(", 78"), _c('i', [_vm._v("–")]), _vm._v("79.")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "ch00rfn7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch00fn7"
    }
  }, [_vm._v("7")]), _vm._v(". Ibid., 78.")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "ch00rfn8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch00fn8"
    }
  }, [_vm._v("8")]), _vm._v(". For instance, the Faure report encouraged the development of multimedia skills for communicating, social studies along with sciences and the study of subjects relevant to human living, the arts as well as technology, manual training as well as physical education (UNESCO, Faure report, 61–69). The Faure report advocated for teaching practices based on cognitive science and psychology and promoted the positive impact of individualized learning programs (chap. 5). Twenty-four years later, the Delors report picked up many of these same themes and translated them to the various levels of schooling, from elementary through university, and in continuing education throughout life (UNESCO, Delors report, chap. 6).")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "ch00rfn9"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "title": "13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch00fn9"
    }
  }, [_vm._v("9")]), _vm._v(". UNESCO, "), _c('i', [_vm._v("Rethinking Education")]), _vm._v(", 64.")])]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "ch00rfn10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch00fn10"
    }
  }, [_vm._v("10")]), _vm._v(". Ibid., 65.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "ch00rfn11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch00fn11"
    }
  }, [_vm._v("11")]), _vm._v(". Ibid., 38.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "ch00rfn12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch00fn12"
    }
  }, [_vm._v("12")]), _vm._v(". Ibid., 48.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "ch00rfn13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch00fn13"
    }
  }, [_vm._v("13")]), _vm._v(". UNESCO, Faure report, xxi.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "ch00rfn14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch00fn14"
    }
  }, [_vm._v("14")]), _vm._v(". Ibid., xxi, xxii.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "ch00rfn15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch00fn15"
    }
  }, [_vm._v("15")]), _vm._v(". Ibid., xxi, xxxiii.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "ch00rfn16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch00fn16"
    }
  }, [_vm._v("16")]), _vm._v(". Ibid., 146.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "ch00rfn17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch00fn17"
    }
  }, [_vm._v("17")]), _vm._v(". UNESCO, Delors report, 11.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "ch00rfn18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch00fn18"
    }
  }, [_vm._v("18")]), _vm._v(". Ibid., 12.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "ch00rfn19"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch00fn19"
    }
  }, [_vm._v("19")]), _vm._v(". Ibid., 20, 21, chap. 4.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "ch00rfn20"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch00fn20"
    }
  }, [_vm._v("20")]), _vm._v(". See for instance, Joseph Shively, “Navigating Music Teacher Education toward Humane Ends”; Blakeley Menghini, “Rethinking Education: The Four Pillars of Education in the Suzuki Studio”; and Johnnie-Margaret McConnell and Susan Laird, “Nourishing the Musically Hungry: Learning from Undergraduate Amateur Musicking,” in this collection.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "ch00rfn21"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch00fn21"
    }
  }, [_vm._v("21")]), _vm._v(". UNESCO, "), _c('i', [_vm._v("Rethinking Education")]), _vm._v(", 36.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "ch00rfn22"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch00fn22"
    }
  }, [_vm._v("22")]), _vm._v(". Ibid., 36, 37.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "ch00rfn23"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch00fn23"
    }
  }, [_vm._v("23")]), _vm._v(". Ibid., 36, 37.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "ch00rfn24"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch00fn24"
    }
  }, [_vm._v("24")]), _vm._v(". Ibid., 38.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "ch00rfn25"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch00fn25"
    }
  }, [_vm._v("25")]), _vm._v(". Ibid., 39, 43, 47–53. See Luca Tiszai, “Friendship, Solidarity, and Mutuality Discovered in Music”; Jacob Berglin and Thomas O’Hara, “Working with Transgender Students as a Humane Act”; Emily Good-Perkins, “Rethinking Vocal Education as a Means to Encourage Positive Identity Development in Adolescents”; Alexandra Kertz-Welzel, Leonard Tan, Martin Berger, and David Lines, “A Humanistic Approach to Music Education: (Critical) International Perspectives”; Eleni Lapidaki, “Toward the Discovery of Contemporary Trust and Intimacy in Higher Music Education”; Betty Ann Younker, “Inquiry-Based Learning: A Value for Music Education with Aims to Cultivate a Humane Society; Mary Thomason-Smith, “Music Education in Sacred Communities: Singing, Learning, and Leading for the Global Common Good,” in this collection.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "ch00rfn26"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch00fn26"
    }
  }, [_vm._v("26")]), _vm._v(". This assumption can be seen, for example, on the website of the American Association of University Professors, in the essay “Education for the Common Good,” posted with the subtitle “The goal of education needs to be more than individual success” (Marcus Peter Ford, “Education for the Common Good,” "), _c('i', [_vm._v("Academe")]), _vm._v(" 102, no. 5 [September 2016], "), _c('a', {
    attrs: {
      "href": "https://www.aaup.org/article/education-common-good#.WcE6_8iGMtI",
      "target": "_blank"
    }
  }, [_vm._v("https://www.aaup.org/article/education-common-good#.WcE6_8iGMtI")]), _vm._v("); in Amy L. Watts, "), _c('i', [_vm._v("Education and the Common Good: The Social Benefits of Higher Education in Kentucky")]), _vm._v(" (Frankfort, KY: Long-term Policy Research Center, 2001), "), _c('a', {
    attrs: {
      "href": "http://e-archives.ky.gov/pubs/LPRC/education_and_the_common_good(2001).pdf",
      "target": "_blank"
    }
  }, [_vm._v("http://e-archives.ky.gov/pubs/LPRC/education_and_the_common_good(2001).pdf")]), _vm._v("; and in the “core values of equity, quality, transparency, accountability and community” professed by the North Carolina State Board of Public Education at “Public Education for the Common Good,” NC State Board of Public Education, accessed September 19, 2017, "), _c('a', {
    attrs: {
      "href": "https://stateboard.ncpublicschools.gov/resources/public-education-for-the-common-good-1",
      "target": "_blank"
    }
  }, [_vm._v("https://stateboard.ncpublicschools.gov/resources/public-education-for-the-common-good-1")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "ch00rfn27"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch00fn27"
    }
  }, [_vm._v("27")]), _vm._v(". UNESCO, Faure report, 55.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "ch00rfn28"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch00fn28"
    }
  }, [_vm._v("28")]), _vm._v(". Ibid., 56.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "ch00rfn29"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch00fn29"
    }
  }, [_vm._v("29")]), _vm._v(". Ibid., chap. 4.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "ch00rfn30"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch00fn30"
    }
  }, [_vm._v("30")]), _vm._v(". Ibid., 151. This theme was taken up again by the National Taskforce on Civic Learning and Democratic Engagement, "), _c('i', [_vm._v("A Crucible Moment: College Learning and Democracy’s Future")]), _vm._v(", "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "title": "14"
    }
  }, [_vm._v("accessed September 20, 2017, "), _c('a', {
    attrs: {
      "href": "https://aacu.org/sites/default/files/files/crucible/Crucible_508F.pdf",
      "target": "_blank"
    }
  }, [_vm._v("https://aacu.org/sites/default/files/files/crucible/Crucible_508F.pdf")]), _vm._v(", first published in 2012.")])]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "ch00rfn31"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch00fn31"
    }
  }, [_vm._v("31")]), _vm._v(". UNESCO, Delors report, chap. 2.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "ch00rfn32"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch00fn32"
    }
  }, [_vm._v("32")]), _vm._v(". Ibid., chap. 1.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "ch00rfn33"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch00fn33"
    }
  }, [_vm._v("33")]), _vm._v(". Ibid., 11.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "ch00rfn34"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch00fn34"
    }
  }, [_vm._v("34")]), _vm._v(". Ibid., 31, 32.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "ch00rfn35"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch00fn35"
    }
  }, [_vm._v("35")]), _vm._v(". Ibid., chap. 5.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "ch00rfn36"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch00fn36"
    }
  }, [_vm._v("36")]), _vm._v(". UNESCO, "), _c('i', [_vm._v("Rethinking Education")]), _vm._v(", 78.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "ch00rfn37"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch00fn37"
    }
  }, [_vm._v("37")]), _vm._v(". For a further discussion of these tensions, see Iris M. Yob, “There Is No Other,” in this collection.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bdb838e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/00b_Yob_and_Jorgensen_introduction_prod.vue
// module id = 78
// module chunks = 0